<section class="journey-crafted-section">
  <div class="journey-crafted-container">

    <!-- Header -->
    <div class="journey-crafted-header">
      <div class="header-icon-wrapper">
      </div>
      <h2 class="journey-crafted-title">Your Journey, Crafted with Care</h2>
    </div>

    <!-- Cards Grid -->
    <div class="journey-cards-grid">

      <div
        *ngFor="let card of journeyCards"
        class="journey-service-card"
      >
        <div class="service-card-inner">

          <!-- Image Section -->
          <div class="service-card-image">
            <img [src]="card.image" [alt]="card.title" />
            <div class="image-overlay"></div>
          </div>

          <!-- Content Section -->
          <div class="service-card-content">
            <div class="content-text-area">
              <h3 class="service-card-title">{{ card.title }}</h3>
              <p class="service-card-subtitle">{{ card.subtitle }}</p>

              <div class="service-card-details">
                <p class="detail-price" *ngIf="card.price">{{ card.price }}</p>
                <p class="detail-description">{{ card.description }}</p>
                <p class="detail-additional" *ngIf="card.additionalInfo">
                  {{ card.additionalInfo }}
                </p>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <button
              type="button"
              class="service-action-button"
              (click)="handleCardAction(card)"
            >
              <span>{{ card.buttonText }}</span>
              <div style="background-color: rgba(241, 101, 18, 1);
                padding: 8px 10px;
                border-radius: 50%;">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 16 16 12 12 8"/>
                <line x1="8" y1="12" x2="16" y2="12"/>
              </svg>
              </div>

            </button>
            </div>

          </div>

        </div>
      </div>

    </div>

  </div>
</section>
